import { createSlice } from "@reduxjs/toolkit";
import { getFromServerTopic } from "../utility/slice";

const SLICE = "energystarRatings";

export const getEnergyStarRatings = getFromServerTopic({
  topic: SLICE,
  action: "getEnergyStarRatings",
  payloadFn: async (payload) => {
    return payload;
  },
});

export const slice = createSlice({
  name: SLICE,
  initialState: {
    siteRatings: {},
  },
  reducer: {},
  extraReducers: (builder) => {
    builder.addCase(getEnergyStarRatings.fulfilled, (state, action) => {
      state.siteRatings[`${action.meta.arg.siteId}`] = {
        ...state.siteRatings[`${action.meta.arg.siteId}`],
        rating: action.payload.response,
      };
    });
  },
});

export default slice.reducer;
